import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { blue, green } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

const illustrationTokens = [
  { propertyPath: 'blue1', tokenName: '--bg-illustration-blue1' },
  { propertyPath: 'blue2', tokenName: '--bg-illustration-blue2' },
  { propertyPath: 'green1', tokenName: '--bg-illustration-green1' },
  { propertyPath: 'green2', tokenName: '--bg-illustration-green2' },
] satisfies Token[];

export const illustrationTokenMetadata: PaletteTokenMetadata = {
  componentName: 'illustration',
  tokens: illustrationTokens,
};

export const illustration = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['illustration'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(illustrationTokens, tokens, xcorTokens);
  }
  return mode === 'light'
    ? {
        blue1: blue[100],
        blue2: blue[200],
        green1: green[100],
        green2: green[300],
      }
    : {
        blue1: blue[800],
        blue2: blue[700],
        green1: green[800],
        green2: green[600],
      };
};
